'use client';

/**
 * Navigation Provider Wrapper
 *
 * Client component wrapper for NavigationProvider.
 * This is needed because template.tsx is a server component,
 * but NavigationProvider uses client-side hooks (usePathname, useState, etc.)
 *
 * This wrapper:
 * - Bridges server → client boundary
 * - Receives userId and organizationId from server
 * - Passes them to NavigationProvider
 */

import { ReactNode } from 'react';
import { NavigationProvider } from './NavigationProvider';

interface NavigationProviderWrapperProps {
  children: ReactNode;

  /** User ID for cache invalidation and permission filtering */
  userId: string | null;

  /** Organization ID for org-specific menu overrides */
  organizationId: string | null;

  /** Feature flags for conditional menu items */
  featureFlags?: Record<string, boolean>;
}

export function NavigationProviderWrapper({
  children,
  userId,
  organizationId,
  featureFlags = {},
}: NavigationProviderWrapperProps) {
  return (
    <NavigationProvider
      userId={userId}
      organizationId={organizationId}
      featureFlags={featureFlags}
    >
      {children}
    </NavigationProvider>
  );
}

export default NavigationProviderWrapper;
